import { CAMPAIGN_SENDER_AND_EVENT_VARIABLE_LABELS } from "@signalist/shared-types";

import suggestionsData from "@/utils/suggestions";

import { EventOutreachSchemaType, ListPerson } from "../../../schema/list";
import { ColumnConfig } from "../../../schema/columnConfig";

export const getSuggestionLabel = (
	key: string,
	currentPerson?: ListPerson | null,
	listColumns?: ColumnConfig[],
	listEvent?: EventOutreachSchemaType | null
) => {
	const mySuggestions: { [key: string]: string | number } = {
		...suggestionsData.suggestions,
		// The sender tokens and the shared event-outreach variables (PREC-3520), named in
		// shared-types so the API's list_campaign_variables uses the same labels (PREC-4370).
		...CAMPAIGN_SENDER_AND_EVENT_VARIABLE_LABELS,
	};

	if (currentPerson && currentPerson.list.columns && currentPerson.list.columns.length > 0) {
		currentPerson.list.columns.forEach((column) => {
			mySuggestions[`column_${column.id}_${column.name}`] = column.name;
		});
	}

	// Fallback: derive labels from person-level columns (available in all-prospects API)
	if (currentPerson && currentPerson.columns && currentPerson.columns.length > 0) {
		currentPerson.columns.forEach((column) => {
			mySuggestions[`column_${column.columnConfigId}_${column.columnConfig.name}`] =
				column.columnConfig.name;
		});
	}

	// Fallback: derive labels from list-level column configs when no person is available
	if (listColumns && listColumns.length > 0) {
		listColumns.forEach((column) => {
			if (column.id) {
				mySuggestions[`column_${column.id}_${column.name}`] = column.name;
			}
		});
	}

	// Custom event variables (PREC-3520) — the key IS the token; label it with the key so the
	// dropdown/picker doesn't filter it out for a missing label.
	if (listEvent?.enabled) {
		listEvent.customVariables?.forEach((variable) => {
			if (variable.key) {
				mySuggestions[variable.key] = variable.key;
			}
		});
	}

	return mySuggestions[key] as string;
};
